export default __webpack_public_path__ + "static/media/2 - Благоустройство пространства у метро.7ba60033.jpg";